var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.is_one_photo == 1)?_c('one-photo-details',{attrs:{"logo_one":_vm.logo_one,"logo_two":_vm.logo_two}}):_c('two-photos-details',{attrs:{"logo_one":_vm.logo_one,"logo_two":_vm.logo_two}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e30c2d66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/photoDocumentation/components/PhotoDetails/PhotoDetails.vue
// module id = null
// module chunks = 